export const unitsEnum = {
  enum: ["kilometers", "miles", "degrees", "radians"]
};
